module.exports = __webpack_public_path__ + "static/media/background.942b3693.png";